import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=22dc6fe8"
import script from "./UserEditDialog.js?vue&type=script&lang=js&external"
export * from "./UserEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports